<template>
  <header class="flex">
    <div class="left">Timecrimes</div>
    <div class="right">no time management is a crime</div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader'
}
</script>

<style>
header {
  background: var(--background-secondary);
  color: var(--color-secondary);
  padding: 1em;
}
.left {
  text-align: left;
}
.right {
  text-align: right;
}
</style>
